import { API_URL } from '../../../../utils/config';

export const SCHEDULE_USER_URL = `${API_URL}/installation`;
export const GET_CATEGORIES_FOR_INSTALLATION_URL = `${API_URL}/product`;
export const GET_SUBZONES_URL = `${API_URL}/subzone`;
export const GET_AVAILABLE_TIMES_URL = `${API_URL}/checkavailabletime`;
